var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6499 6.14844C10.926 6.14844 11.1499 6.3723 11.1499 6.64844V10.1484H14.6499C14.926 10.1484 15.1499 10.3723 15.1499 10.6484C15.1499 10.9246 14.926 11.1484 14.6499 11.1484H11.1499V14.6484C11.1499 14.9246 10.926 15.1484 10.6499 15.1484C10.3738 15.1484 10.1499 14.9246 10.1499 14.6484V11.1484H6.6499C6.37376 11.1484 6.1499 10.9246 6.1499 10.6484C6.1499 10.3723 6.37376 10.1484 6.6499 10.1484H10.1499V6.64844C10.1499 6.3723 10.3738 6.14844 10.6499 6.14844Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3C6.11725 3 3 6.35665 3 10.5238C3 14.6869 6.11342 18 10.5 18C14.8866 18 18 14.6869 18 10.5238C18 6.35665 14.8827 3 10.5 3ZM2 10.5238C2 5.82807 5.54155 2 10.5 2C15.4584 2 19 5.82807 19 10.5238C19 12.7796 18.1831 14.8228 16.7856 16.3378L21.8441 21.1373C22.0445 21.3273 22.0528 21.6438 21.8627 21.8441C21.6727 22.0445 21.3562 22.0528 21.1559 21.8627L16.0626 17.0303C14.6073 18.2611 12.6915 19 10.5 19C5.54538 19 2 15.2233 2 10.5238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomin);
export default __webpack_public_path__ + "static/media/zoomin.c054297b08311f2f6700bac513d5a08f.svg";
export { ForwardRef as ReactComponent };